<template>
    <div>
        <!-- Campo de busca geral -->
        <input type="text" v-model="search" placeholder="Buscar conteúdo..." class="search-input" />

        <!-- Filtros -->
        <div class="filtros">
            <form @submit.prevent>
                <div>
                    <select v-model="filtroArea" class="form-control">
                        <option value="" class="option">Escolha uma área</option>
                        <option v-for="area in listaArea" :key="area.codigo_grupo" :value="area.codigo_grupo" class="option">
                            {{ area.nome_grupo }}
                        </option>
                    </select>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import '../styles/Library.css';
import request from '../router/request';

export default {
    name: 'Search',
    data() {
        return {
            search: '',
            filtroLivro: '',
            filtroArea: '', // ← será código_grupo
            listaArea: [],
        };
    },
    watch: {
        search() {
            this.emitirFiltro();
        },
        filtroArea() {
            this.emitirFiltro();
        }
    },
    methods: {
        emitirFiltro() {
            this.$emit('filtro-atualizado', {
                texto: this.search,
                area: this.filtroArea
            });
        }
    },
    mounted() {
        // 🔹 Carrega lista de áreas
        request
            .post('/portal/listarGruposConhec')
            .then((response) => {
                this.listaArea = response.data.filter(area => area.codigo_grupo !== 10); 
            })
            .catch((error) => {
                console.error('Erro ao buscar grupos de conhecimento:', error);
            });
    },
};
</script>